import axios from 'axios';

let baseURL;

// Esta es la forma robusta de definir la URL base.
// Si el entorno es 'production' (definido automáticamente por 'npm run build'),
// usa la URL de AWS. De lo contrario, usa la variable de entorno para local.
if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://api.tuplazita.com';
} else {
  baseURL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
}

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar el token a las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('token');
      localStorage.setItem('sessionExpired', '1');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
